import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_PATIENT_APPOINTMENT_LIST,
    getPatientAppointmentListFail,
    getPatientAppointmentListSuccess
} from '../action/getPatientAppointmentListAction'

// api 
import getPatientAppointmentListApi from '../api/getPatientAppointmentListApi'

export function* getPatientAppointmentListSaga(action) {
    try {
        const response = yield call(() => getPatientAppointmentListApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(getPatientAppointmentListSuccess(response, action))
        } else {
            yield put(getPatientAppointmentListFail(response, action))
        }
    }
    catch (e) {
        yield put(getPatientAppointmentListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_PATIENT_APPOINTMENT_LIST, getPatientAppointmentListSaga)
}